import { useEffect } from 'react';

const IdleTimer = ({ timeout, onIdle }: any) => {
  const events = [
    // Window Events
    'load',
    'unload',
    // Mouse Events
    'mouseup',
    'mousemove',
    'mouseenter',
    'mouseout',
    'mouseover',
    'mousedown',
    'click',
    'dblclick',
    // Miscellaneous Events:
    'scroll',
    // Keyboard Events
    'keydown',
    'keyup',
    'keypress',
    //Form Events
    'submit',
    'change',
    'input',
  ];

  useEffect(() => {
    let timer: any;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(onIdle, timeout);
    };

    const handleUserActivity = () => {
      resetTimer();
    };

    // Attach event listeners for user activity
    Object.values(events)?.forEach((item) =>
      document.addEventListener(item, handleUserActivity),
    );

    // Initialize the timer
    resetTimer();

    // Cleanup event listeners on component unmount
    return () => {
      Object.values(events)?.forEach((item) =>
        document.removeEventListener(item, handleUserActivity),
      );
      clearTimeout(timer);
    };
  }, [timeout, onIdle]);

  return null;
};

export default IdleTimer;
